module.exports = __webpack_public_path__ + "media/src/site/images/gears-74a592c448a153a10ff4500513fd23fd.svg";